<template>
    <vs-input-number
      :min="min"
      :step="step"
      v-model="MaxActionScore"
      @input="setVal"
    />
</template>

<script>
export default {
  name: 'CellMaxScore',
  data() {
    return {
      min:1,
      step:1,
      MaxActionScore: 1,
    }
  },
  created(){
    this.MaxActionScore  = Number(this.params.value)
  },
  methods:{
    setVal(){
      this.params.setValue(Number(this.MaxActionScore))
    }
  },
}
</script>